import React, { memo } from 'react'
import { useAddToCart } from './useAddToCart'
import styles from './AddToCart.module.scss'

const AddToCart: React.FC<{ productId: number }> = ({ productId }) => {
  const {
    isAddingToCart,
    hasVariants,
    hasLongNames,
    priceList,
    handleToggle,
    isVariantAdded,
  } = useAddToCart({ productId })

  if (hasVariants) {
    return (
      <div
        className={`${styles['variants-container']} ${
          hasLongNames ? styles['long-names-mode'] : ''
        }`}
      >
        {priceList.map((variant) => {
          const added = isVariantAdded(variant.name)
          return (
            <button
              key={variant.name}
              type='button'
              className={`${styles['variant-btn']} ${
                hasLongNames ? styles['long-variant-btn'] : ''
              } ${added ? styles['active'] : ''}`}
              onClick={() => handleToggle(variant.name)}
              disabled={isAddingToCart}
            >
              {variant.name}
            </button>
          )
        })}
      </div>
    )
  }

  const added = isVariantAdded(null)
  return (
    <button
      type='button'
      className={`${styles['add-to-cart-container']} ${
        added ? styles['is-added'] : ''
      }`}
      style={{ opacity: isAddingToCart ? 0.5 : 1 }}
      disabled={isAddingToCart}
      onClick={() => handleToggle(null)}
    >
      <i className={`bi ${added ? 'bi-cart-check-fill' : 'bi-cart-plus'}`}></i>
    </button>
  )
}

export default memo(AddToCart)
